import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import { accountGroupsV4PerformanceEntireKeyMaker } from "../requests/getAccountGroupPerformancesV4";
import postAccountGroupsV4 from "../requests/postAccountGroupsV4";
import { accountGroupsV4KeyMaker } from "./useGetAccountGroupsV4";
export default function usePostAccountGroupsV4(config) {
    const queryClient = useQueryClient();
    const idemDescriptor = "post-account-groups-v4";
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(idemDescriptor));
    const mutation = useMutation({
        mutationFn: async (body) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return postAccountGroupsV4(body, idempotencyKey, config);
        },
        onSuccess: (_, { ownerId }) => {
            setIdempotencyKey(genIdempotencyKey(idemDescriptor));
            queryClient.invalidateQueries({
                queryKey: accountGroupsV4KeyMaker(),
            });
            // AGs performance
            queryClient.invalidateQueries({
                queryKey: accountGroupsV4PerformanceEntireKeyMaker(ownerId),
            });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=usePostAccountGroupsV4.js.map